import styled from 'styled-components';

// @ts-ignore
import Tab from '@r1-frontend/ui-react/components/tabs/tab';
// @ts-ignore
import Tabs from '@r1-frontend/ui-react/components/tabs/tabs';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const HomeInternetContainer = styled.div`
    width: 100%;
    box-sizing: content-box;
    margin: 32px 0;
`;

export const STab = styled(Tab)`
    outline: 1px solid red;
    margin: 10px 0 0 0;
`;

export const STabs = styled(Tabs)`
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;

    & > div:first-child {
        display: flex;
        flex-wrap: nowrap;
        width: fit-content;
        border: 2px solid ${COLORS.Outline_Light};
        border-radius: 100px;
        margin: 32px 0 24px;
        padding: 2px;
        user-select: none;
        white-space: nowrap;

        > div > div > div {
            div {
                display: flex;
                align-items: center;
                ${FONTS.MediumXS};
                background-color: ${props => props.active ? COLORS.ButtonPrimary : 'transparent'};
                color: ${props => props.active ? COLORS.TextWhite : COLORS.TextPrimary};
                padding: 6px 24px;
                border-radius: 100px;
                margin-left: 8px;
                cursor:  pointer;
            }
        }
    }
`;

export const HomeInternetTitle = styled.h2`
    color: ${COLORS.TextPrimary};
    ${FONTS.H2};

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H4};
    }
`;
